<template>
  <div>
    <div
      v-if="app_loaded && (booksList.length || events.length || booksAgent.length || user.parent)"
      class="myhome-home"
    >
      <NotificationStripeContainer
        v-if="messagesByType.myHomeHomeStripe.length"
        :messages="messagesByType.myHomeHomeStripe"
        :role="user.role"
      />
      <HomeHeaderButtons v-if="!user.agent" :link-color="user.targetCss.colorMod" :role="user.role">
        <template #button-left>
          <ButtonActivateCopy
            v-if="user.student || user.parent"
            :role="user.role"
            :link-color="user.targetCss.colorMod"
          />
          <ButtonCourses v-else-if="user.generic" :role="user.role" />
          <ButtonSupport
            v-else
            :role="user.role"
            :link-color="user.targetCss.colorMod"
            :user-authenticated="user.authenticated"
            :agents-url="agentsUrl"
          />
        </template>
        <template #button-right>
          <ButtonSupport
            v-if="user.student || user.parent || user.generic"
            :role="user.role"
            :link-color="user.targetCss.colorMod"
            :agents-url="agentsUrl"
          />
          <ButtonSwitchUser v-else-if="user.parent_id" :user="user" @open-profile-modal="openProfileModal" />
          <ButtonEvaluationCopy
            v-else
            :role="user.role"
            :link-color="user.targetCss.colorMod"
            :catalog-link="catalogLink"
            @open-evaluation-modal="showEvaluationModal = true"
          />
        </template>
      </HomeHeaderButtons>
      <HomeAgentBooks v-if="user.can_impersonate_role" :user="user" :books="booksAgent" />
      <HomeStudentBooks
        v-else-if="user.student"
        :user="user"
        :books="booksList"
        :aed="aed"
        :loaded="loaded"
        @open-activation-modal="showActivationModal = true"
        @open-evaluation-modal="showEvaluationModal = true"
        @update-books-list="$emit('update-books-list')"
      />
      <HomeTeacherBooks
        v-else-if="!user.parent && !user.generic"
        :user="user"
        :books="booksList"
        :aed="aed"
        :loaded="loaded"
        @open-activation-modal="showActivationModal = true"
        @open-evaluation-modal="showEvaluationModal = true"
        @update-books-list="$emit('update-books-list')"
      />
      <HomeFamilyBooks
        v-else-if="user.children_map"
        :user="user"
        :aed="aed"
        :books="booksList"
        :show-children="true"
        :children-books="childrenBooksList"
        :children-aed="childrenAed"
        :loaded="loaded"
        @open-profile-modal="openProfileModal"
        @open-activation-modal="showActivationModal = true"
        @open-evaluation-modal="showEvaluationModal = true"
        @update-books-list="$emit('update-books-list')"
      />
      <HomeEvents v-if="user.teacher" :user="user" :events="events" />
      <HomeBookmarks v-if="!user.agent" :user="user" :bookmarks="bookmarks" />
    </div>
    <div v-else-if="app_loaded && !booksList.length && !events.length && !booksAgent.length && !user.parent">
      <EmptyHome
        :link-color="user.targetCss.colorMod"
        :generic="user.generic"
        :principal="user.principal"
        :parent="user.parent"
        :student="user.student"
        :user="user"
        @open-activation-modal="showActivationModal = true"
        @open-evaluation-modal="showEvaluationModal = true"
      />
    </div>
    <BookEvaluationModal
      v-if="showEvaluationModal"
      :config="$root.config.evaluationSearch"
      :link-color="user.targetCss.colorMod"
      :catalog-link="catalogLink"
      :personal-area-logo-list="personalAreaLogoList"
      :user="user"
      @close-modal="showEvaluationModal = false"
    >
      <EvaluationModalContent />
    </BookEvaluationModal>
    <BookEvaluationModal
      v-if="showActivationModal"
      :config="$root.config.activationSearch"
      :link-color="user.targetCss.colorMod"
      :catalog-link="catalogLink"
      :personal-area-logo-list="personalAreaLogoList"
      :user="user"
      @close-modal="showActivationModal = false"
    >
      <ActivationModalContent />
    </BookEvaluationModal>
    <ProfileModal
      v-if="showProfileModal"
      :visible="showProfileModal"
      :local-child="localUser"
      @open-child-profile="openChildProfile"
      @open-child-my-home="openChildMyHome"
      @close-modal="showProfileModal = false"
    />
  </div>
</template>

<script>
import VueCookies from "vue-cookies";

import { mapGetters } from "vuex";
import NotificationStripeContainer from "@/components/elements/NotificationStripeContainer";
import SearchMixin from "@/components/mixins/search";
import switchChildrenUser from "@/components/mixins/switchChildrenUser";
import myHomeBooks from "~/mixins/myHomeBooks";
import BookEvaluationModal from "~/components/books/components/BookEvaluationModal";
import EmptyHome from "~/components/books/components/EmptyHome";
import HomeEvents from "~/components/books/components/HomeEvents";
import HomeTeacherBooks from "~/components/books/components/HomeTeacherBooks";
import HomeAgentBooks from "~/components/books/components/HomeAgentBooks";
import HomeFamilyBooks from "~/components/books/components/HomeFamilyBooks";
import HomeStudentBooks from "~/components/books/components/HomeStudentBooks";
import HomeHeaderButtons from "~/components/books/components/HomeHeaderButtons";
import ActivationModalContent from "~/components/books/components/ActivationModalContent";
import EvaluationModalContent from "~/components/books/components/EvaluationModalContent";
import ButtonEvaluationCopy from "~/components/books/components/ButtonEvaluationCopy";
import ButtonSupport from "~/components/books/components/ButtonSupport";
import ButtonActivateCopy from "~/components/books/components/ButtonActivateCopy";
import ButtonSwitchUser from "~/components/books/components/ButtonSwitchUser";
import ButtonCourses from "~/components/books/components/ButtonCourses";
import HomeBookmarks from "~/components/books/components/HomeBookmarks";
import ProfileModal from "~/components/books/components/ProfileModal";
import UserLinks from "~/components/books/mixins/UserLinks";

export default {
  name: "MyHomeHome",
  components: {
    BookEvaluationModal,
    HomeTeacherBooks,
    EmptyHome,
    HomeEvents,
    HomeAgentBooks,
    HomeFamilyBooks,
    HomeStudentBooks,
    HomeHeaderButtons,
    ActivationModalContent,
    EvaluationModalContent,
    ButtonEvaluationCopy,
    ButtonSupport,
    ButtonActivateCopy,
    ButtonCourses,
    ButtonSwitchUser,
    HomeBookmarks,
    ProfileModal,
    NotificationStripeContainer,
  },
  mixins: [myHomeBooks, SearchMixin, switchChildrenUser, UserLinks],
  props: {
    aed: {
      type: Array,
      default: () => [],
    },
    books: {
      type: Array,
      required: true,
    },
    bookmarks: {
      type: Array,
      default: () => [],
    },
    booksAgent: {
      type: Array,
      default: () => [],
    },
    childrenAed: {
      type: Object,
      default: () => {},
    },
    childrenBooks: {
      type: Object,
      default: () => {},
    },
    events: {
      type: Array,
      default: () => [],
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    personalAreaLogoList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      aed_items: this.aed,
      app_loaded: this.loaded,
      localUser: null,
      showProfileModal: false,
      showEvaluationModal: false,
      showActivationModal: false,
    };
  },
  computed: {
    ...mapGetters(["config", "messagesByType"]),
  },
  watch: {
    loaded() {
      this.app_loaded = this.loaded;
    },
  },
  methods: {
    logout() {
      VueCookies.remove("deatoken_parent", "/", ".deascuola.it");
      VueCookies.remove("deatarget", "/", ".deascuola.it");
      VueCookies.remove("deahome", "/", ".deascuola.it");
      let returnUrl;
      // pages outside public_url are protected by login and we can't redirect there after logout
      // this logic might need revision when applied to deascuola
      if (document.location.href.indexOf(this.config.publicURL) === 0) returnUrl = document.location.href;
      else returnUrl = this.config.publicURL;
      document.location = `${this.config.logout_url}?force_return=true&url=${returnUrl}`;
    },
    openChildMyHome(child) {
      document.querySelector("body").classList.add("wait");
      if (this.user.parent_id) {
        this.logout();
      } else {
        this.fetchChild(this.$root.config.parent_login, child, document.location.href);
      }
    },
    openChildProfile(child) {
      document.querySelector("body").classList.add("wait");
      this.fetchChild(this.$root.config.parent_login, child, this.$root.config.profile_student_url);
    },
    openProfileModal(userData) {
      this.showProfileModal = true;
      this.localUser = userData;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-home {
  &__mybooks-header {
    margin-bottom: $space-base;
  }

  &__mybooks-container {
    @include media("<=m") {
      flex-wrap: wrap;
    }
    display: flex;
  }

  &__mybooks-link {
    margin-top: $space-m-small;
  }
}
</style>
